import { useState } from 'react'
import { TRANSCRIPTION_LANGUAGES } from '@mote/helpers/constants'

function getLanguage(lang: string | null) {
  const langCode = lang ?? 'en-US'
  const [code, name] = TRANSCRIPTION_LANGUAGES.find(
    ([code]) => code === langCode
  )!
  return { code, name }
}

type TranscriptionLocale = {
  code: string
  name: string
}

export const useTranscriptionLocale = () => {
  const [transcriptionLocale, setTranscriptionLocale] =
    useState<TranscriptionLocale>(() => {
      const locale =
        window.localStorage.getItem('userSelectedTranscriptionLocale') ??
        window.localStorage.getItem('mote-auth-recommendedTranscriptionLocale')

      return getLanguage(locale)
    })

  function setLocale(locale: string) {
    window.localStorage.setItem('userSelectedTranscriptionLocale', locale)
    setTranscriptionLocale(getLanguage(locale))
  }

  return [transcriptionLocale, setLocale] as const
}
